import { MAILING_CONTAINERS_LIST } from 'shared/enums';
import { ITabList } from 'interfaces/utils';

import MailingRule from './MailingRule';
import Strategy from './Strategy';

export const tabs = {
  [MAILING_CONTAINERS_LIST.MAILING_RULES]: {
    Component: MailingRule,
    label: 'Regras',
    key: 'mailingRules',
  },
  [MAILING_CONTAINERS_LIST.MAILING_STRATEGIES]: {
    Component: Strategy,
    label: 'Estratégias',
    key: 'strategy',
  },
} as ITabList;

export const tabsKeys = Object.keys(tabs);
export const tabsEntries = Object.entries(tabs);
